import { gql } from "@apollo/client";
import { AxeFragment, StopFragment, TemplateAxeFragment } from "./fragments";

export const GET_ALL_MISSIONS = gql`
  query getAllMissions($queries: AllMissionFetchQueries) {
    results: getAllMissions(queries: $queries) {
      error
      code
      countTotal
      totalPages
      currentPage
      data {
        uid
        client {
          client_company_name
        }
        address {
          region
          address
        }
        axes {
          ...AxeFragment
        }
        stops {
          ...StopFragment
        }
        status
        type
        executionDate
        slotStart
        slotEnd
        vehicleType
        productType
        requestId
        request {
          _id
          uid
          startDate
          endDate
          templateAxes {
            ...TemplateAxeFragment
          }
        }
        createdAt
        tasks {
          _id
          type
          runsheetId
          action
          status
          vehiculeType
          uid
          executionDate
          driverId
          stops {
            ...StopFragment
          }
          task_driver {
            driver_firstname
            driver_lastname
          }
          activities {
            _id
            activity_date
            activity_trigger_action
            activity_trigger_action_previous_data
            activity_trigger_action_next_data
            activity_trigger_action_data
            activity_trigger_action_data_reason
            activity_trigger_by_user_id
            activity_trigger_source
            activity_updated_by {
              first_name
              last_name
            }
          }
        }
        _id
        vehicles {
          vehicleType
        }
        runsheet {
          _id
          runsheet_driver {
            driver_firstname
            driver_lastname
          }
        }
      }
    }
  }
  ${AxeFragment}
  ${StopFragment}
  ${TemplateAxeFragment}
`;

export const FETCH_MISSION_BADGE_BY_TYPES = gql`
  query fetchMissionBadgeByType($queries: BadgeMissionsQueries!) {
    results: fetchMissionBadgeByType(queries: $queries) {
      error
      code
      message
      data {
        key
        value
      }
    }
  }
`;
